/**
 * Detects whether an element's background color is dark or light
 * by computing its perceived luminance from the resolved CSS background-color.
 */
export function isDarkBackground(element: HTMLElement): boolean {
    const style = getComputedStyle(element);
    const bg = style.backgroundColor;
    const match = bg.match(/\d+/g);
    if (!match || match.length < 3) return false;
    const [r, g, b] = match.map(Number);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance < 0.5;
}

export function getColorMode(element: HTMLElement): "dark" | "light" {
    return isDarkBackground(element) ? "dark" : "light";
}

/**
 * Classify a hex color (#rgb or #rrggbb) as dark or light by perceived luminance.
 * Returns "light" for any unparseable input.
 */
export function getColorModeFromHex(hex: string | undefined | null): "dark" | "light" {
    if (!hex) return "light";
    const cleaned = hex.replace("#", "");
    const expanded = cleaned.length === 3
        ? cleaned.split("").map((c) => c + c).join("")
        : cleaned;
    if (expanded.length < 6) return "light";
    const r = parseInt(expanded.slice(0, 2), 16);
    const g = parseInt(expanded.slice(2, 4), 16);
    const b = parseInt(expanded.slice(4, 6), 16);
    if ([r, g, b].some(Number.isNaN)) return "light";
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance < 0.5 ? "dark" : "light";
}
